/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 15.04.14
 * Time: 17:39
 * To change this template use File | Settings | File Templates.
 */

import { BasicTrackingEvent } from "./BasicTrackingEvent";

/**
 * Special event for monitoring korean instance and user's ID identification.
 */
export class SirenInteractionTrackingEvent extends BasicTrackingEvent {
    public cv: string;
    public interactionType: number;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};

        vars.var_data = this.cv;
        vars.var_1 = this.interactionType;

        return vars;
    }
}
